import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';
import { fontPretendard } from '@/styles/themes/variables';

export const Wrapper = styled.section`
  background-color: #1c1e22;
  font-family: ${fontPretendard};
  height: 100vh;
  ${DESKTOP} {
  }
`;

export const Contents = styled.div`
  position: relative;
  padding: 20px 0 0px;
  ${DESKTOP} {
    margin: 0 auto;
  }
`;
